/* eslint-disable import/no-cycle */
import axios from 'axios';
import { displayError } from '../utils/toast/Toast';
import { store } from '../store';

const getUrl = () => {
  switch (process.env.REACT_APP_STAGE) {
    case 'dev':
      return {
        symplApp: process.env.REACT_APP_SYMPL_APP_API_DEV,
        stockManager: process.env.REACT_APP_STOCK_MANAGER_API_DEV,
        errorLogger: process.env.REACT_APP_ERROR_LOGGER_API_DEV
      };
    case 'prod':
      return {
        symplApp: process.env.REACT_APP_SYMPL_APP_API_PROD,
        stockManager: process.env.REACT_APP_STOCK_MANAGER_API_PROD,
        errorLogger: process.env.REACT_APP_ERROR_LOGGER_API_PROD
      };
    default:
      return '';
  }
};

const httpErrorLogger = axios.create({
  baseURL: getUrl().errorLogger,
  headers: {
    'Content-Type': 'application/json'
  }
});

httpErrorLogger.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    if (token) {
      /* eslint-disable no-param-reassign */
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

export const http = axios.create({
  baseURL: getUrl().symplApp,
  headers: {
    'Content-Type': 'application/json'
  }
});

http.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    if (token) {
      /* eslint-disable no-param-reassign */
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

http.interceptors.response.use(
  response => {
    if (response.data.success === false) {
      displayError(response.data.errorCode);
      const currentError = {
        code: response.data.errorCode,
        message: response.data.message,
        originCode: 'main',
        url: response.config.baseURL,
        parameters: response.config.data,
        appCode: 'WebApp'
      };
      httpErrorLogger.post('/error-logs', currentError);
    }
    return response;
  },
  error => {
    if (error.response.status === 403) {
      localStorage.removeItem('token');
      store.dispatch({ type: 'RESET_APP' });
    } else {
      displayError(error.response.status);
    }
    return Promise.reject(error.response);
  }
);

export const httpStockManager = axios.create({
  baseURL: getUrl().stockManager,
  headers: {
    'Content-Type': 'application/json'
  }
});

httpStockManager.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    if (token) {
      /* eslint-disable no-param-reassign */
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

httpStockManager.interceptors.response.use(
  response => {
    if (response.data.success === false) {
      displayError(response.data.errorCode);
      const currentError = {
        code: response.data.errorCode,
        message: response.data.message,
        originCode: 'stock',
        url: response.config.baseURL,
        parameters: response.config.data,
        appCode: 'WebApp'
      };
      httpErrorLogger.post('/error-logs', currentError);
    }
    return response;
  },
  error => {
    if (error.response.status === 403) {
      localStorage.removeItem('token');
      store.dispatch({ type: 'RESET_APP' });
    } else {
      displayError(error.response.status);
    }
    return Promise.reject(error.response);
  }
);
